import usePanelContext from 'refactor/hooks/usePanelContext'
import useStore from 'state/knovStore'
import { isMobile } from 'lib/device'
import { getSwiperRef } from 'state/imperativeApis/swiperApi'
import { openRightCore } from 'refactor/panels/openRightCore'
import { Filter } from 'components/filters/useStreamFilters'
import { getPanelNavInputDetail } from 'lib/panelNavMetrics'
import type { PanelNavInputDetail, PanelNavInputEventLike } from 'lib/panelNavMetrics'

export default function useOpenRight(panelId?: string) {
    const { panelId: nativePanelId } = usePanelContext()

    const openRight = (
        filter: Filter,
        opts: {
            panelId?: string
            meta?: Record<string, unknown>
            ensureUnique?: boolean
            suppressAutoReveal?: boolean
            onPanelReady?: (panelId: string) => void
            metricInputEvent?: PanelNavInputEventLike | null
            metricInput?: PanelNavInputDetail
        } = {},
    ) => {
        // Determine anchor panel at the time of action
        let anchorPanelId = panelId || nativePanelId
        if (isMobile) {
            const swiperRef = getSwiperRef()
            const swiper = swiperRef?.current
            if (swiper) {
                const currentIndex = swiper.activeIndex
                const panels = useStore.getState().panels.state
                if (panels[currentIndex]) anchorPanelId = panels[currentIndex].panelId
            }
        }
        return openRightCore({
            anchorPanelId,
            filter,
            panelId: opts.panelId,
            meta: opts.meta,
            metricInput: {
                ...getPanelNavInputDetail(opts.metricInputEvent),
                ...(opts.metricInput || {}),
            },
            ensureUnique: opts.ensureUnique !== undefined ? opts.ensureUnique : true,
            suppressAutoReveal: opts.suppressAutoReveal,
            onPanelReady: opts.onPanelReady,
        })
    }

    return {
        openRight,
    }
}

export function isQuestInPanelToRight(panelId: string, questId: string) {
    const panelToRight = useStore.getState().panels.getPanelToRight(panelId)
    return panelToRight && panelToRight.filter?.questId === questId
}
